<template>
  <div class="content-wrapper">
    <div class="col-sm-12 col-md-6">
      <app-breadcrumb
        page-title="Documentos"
        directory="Acreditación Inicial"
        :icon="'trello'"
      />
    </div>
    <div class="row">
      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Evaluaciones</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
              <th scope="col" class="text-center" style="width: 10%">
                Documento
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.evaluations" :key="key">
              <td class="align-middle">
                {{ inputs.record }}
              </td>
              <td class="align-middle">
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openModal(value)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Documentos</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">Solicitud de acreditación firmada</td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  inputs.user
                    ? `${inputs.user.first_name} ${inputs.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{ inputs.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${inputs.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="inputs.receipt_return_report">
              <td class="align-middle">
                Registro de Ingreso de solicitud de acreditación y acuse recibo
              </td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'receipt_return_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr>
              <td class="align-middle">
                Informe Técnico de Análisis de Expediente y de Toma de Decisión
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'technical_file_analysis_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-for="(value, key) in documents" :key="key + 200">
              <template v-if="value.status.code === '605'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 605)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </template>
            </tr>
            <tr v-for="(value, key) in documents" :key="key + 300">
              <template v-if="value.status.code === '608'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 608)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </template>
            </tr>

            <tr v-for="(value, key) in documents" :key="key + 100">
              <template v-if="value.status.code === '609'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 609)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </template>
            </tr>

            <tr v-for="(value, key) in documents" :key="key">
              <template v-if="value.status.code === '610'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, 610)"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </template>
            </tr>

            <tr>
              <td class="align-middle">Borrador Resolución</td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'draft_resolution')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_605 && inputs.additional_605.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Reunión de la Comisión de Acreditación):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_605 && inputs.additional_605.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_605" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_605', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_608 && inputs.additional_608.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Director de Área):</b> Documentos adicionales para
            subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_608 && inputs.additional_608.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_608" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_608', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_609 && inputs.additional_609.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Coordinación General Técnica):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_609 && inputs.additional_609.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_609" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_609', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_610 && inputs.additional_610.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Elaboración de Informe Jurídico para la Acreditación):</b>
            Documentos adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_610 && inputs.additional_610.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_610" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTabInfo(inputs, 'additional_610', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  props: {
    accId: String,
  },
  data() {
    return {
      isAddEditModalActive: false,
      inputs: {},
      inputsInform: {},
      documents: "",
      status: false,
      full_name_from: String,
      full_name_to: String,
    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.data();
  },
  methods: {
    data() {
      let url = `/accreditationExecutive/directorLegalValidation/613/show?accAppId=${this.accId}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
      let urlInfo = `/accreditationtechnical/generalTechnicalCoordination/generalTechnicalCoordinationReport/accreditationData/${this.accId}`;
      this.axiosGet(urlInfo).then((resp) => {
        this.documents = resp.data.documents;
      });
      this.axiosGet(`/userInfo`).then((response) => {
        if (response.data) {
          this.user_id = response.data.id;
          this.full_name_from = response.data.full_name;
        }
      });

      this.axiosGet(`/technicalReport/${this.accId}/613`)
        .then((response) => {
          if (response.status == 200 && response.data) {
            console.log(response);
            // verificar si ya se edito el pdf por el director de area.
            this.axiosGet(`/technicalReport/${this.accId}/613`).then(
              (resp613) => {
                // this.$store.dispatch("getEvalTest");

                if (response.data.code_status != 613) {
                  this.status = true; // Ocultar Procesar en otros estados posteriores.
                } else {
                  this.status = false; // Ocultar Procesar en otros estados posteriores.
                }

                if (resp613.data.id) {
                  let date = new Date(resp613.data.report_date);
                  date.setDate(date.getDate() + 1);
                  this.inputsInform.from = this.user_id;
                  this.inputsInform = resp613.data;
                  this.inputsInform.id_technical_report =
                    resp613.data.id_technical_report;

                  this.inputsInform.accreditation_id = this.accId;
                  this.inputsInform.report_date = new Date(date);

                  this.receiver_id = resp613.data.juridical_data.id;

                  this.full_name_to = resp613.data.full_name;
                } else {
                  let date = new Date(response.data.report_date);
                  date.setDate(date.getDate() + 1);
                  this.inputsInform.from = this.user_id;
                  this.inputsInform = response.data;
                  this.inputsInform.id_technical_report =
                    response.data.id_technical_report;

                  this.inputsInform.accreditation_id = this.accId;
                  this.inputsInform.report_date = new Date(date);
                  //this.inputs.report_date = new Date(date);
                  this.receiver_id = response.data.juridical_data.id;

                  this.full_name_to = response.data.full_name;
                }
              }
            );
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },
    openTab(obj, fileName, key) {
      if (key) {
        const w = window.open(key, "_blank");
        w.focus();
      } else {
        const w = window.open(obj[fileName].path, "_blank");
        w.focus();
      }
    },

    openTabInfo(accAppId = this.accId, status) {
      if (status == "605") {
        let path = `/evaluator/decision/closureFindingsDecision/view/${accAppId}?tab=Borrador del Informe Técnico`;
        window.open(path, "_blank").focus();
      }
      if (status == "608") {
        let path = `/accreditationReview/decision/areaDirectorReport/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "609") {
        let path = `/accreditationtechnical/generalTechnicalCoordination/generalTechnicalCoordinationReport/view/${accAppId}?tab=Evaluación%20/%20Testificación`;
        window.open(path, "_blank").focus();
      }
      if (status == "610") {
        let path = `/accreditationExecutive/legalValidation/610/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      /* let path = `/evaluator/decision/closureFindingsDecision/view/${accAppId}?tab=Borrador del Informe Técnico`;
      window.open(path, "_blank").focus(); */
    },
  },
};
</script>

<style></style>
